import React , { Component, PropTypes } from 'react'
import AuteurLiensTable from './AuteurLiensTable.jsx'
import EditLienModal from './EditLienModal.jsx'
import AppDispatcher, {actions} from '../../shared/dispatcher/AppDispatcher.js';


class AuteurLiens extends Component{
	constructor(props){
		super(props);
		this.state = {'editing': false, 'editlien' : {'id':null, 'href': null, 'ltitle': null, 'ldesc': null}};
		this.handleEdit = this.handleEdit.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.addLien = this.addLien.bind(this);
	}
	
	componentDidMount(){
		if (this.props.liens && this.props.liens.length > 0){
			console.log('liens already fetched');
		} else {
			this.props.fetchAuteurLiens(aid);
		}
	}

	handleEdit(id){

		let l = this.props.liens.find((e)=>{
			return e.id === id;
			});
		this.setState({editlien: l, editing: true});
	}

	handleHide(){
		this.props.hideAuteurLien(aid,this.state.editlien.id)
		.then((res)=>{
          	this.setState({'editing': false});
            AppDispatcher.emit(actions.notifMsg,{'message': 'Le lien a été rendu invisible', 
	            	'level' : 'success', 'title':'Suppression de lien'}); 
		})
		.fail((error)=>{
            AppDispatcher.emit(actions.notifMsg,{'message': error || 'Une erreur imprévue a eu lieu', 
            	'level' : 'error', 'title':'Sauvegarde de lien'});   				
		})
	}

	handleClose(){
		this.setState({'editing': false});
	}

	addLien(){
		this.setState({editing: true, editlien:{'href': null, 'id': undefined, 'ldesc': null, 'ltitle': null}});
	}

	handleSubmit(e){
		e.id = this.state.editlien.id || undefined;
		this.props.saveAuteurLien(aid,e)
			.then((res)=>{
            	this.setState({'editing': false});
	            AppDispatcher.emit(actions.notifMsg,{'message': 'Le lien a été modifié', 
	            	'level' : 'success', 'title':'Sauvegarde de lien'}); 
			})
			.fail((error)=>{
	            AppDispatcher.emit(actions.notifMsg,{'message': error || 'Une erreur imprévue a eu lieu', 
	            	'level' : 'error', 'title':'Sauvegarde de lien'});   				
			})
	}

    render(){
        return (
        	<div>
	            <AuteurLiensTable liens={this.props.liens} 
	            	loading={this.props.loading} handleEdit={this.handleEdit} loginok={this.props.loginok} />
	            
	            <EditLienModal show={this.state.editing} processing={this.props.processing}
	            	lien={this.state.editlien}
	            	handleSubmit={this.handleSubmit} 
	            	handleHide={this.handleHide.bind(this)}
	            	handleClose={this.handleClose} 
	            />
	            {this.props.loginok == 1 && (
	            	<button className="btn btn-link" style={{'marginTop': '10px'}} onClick={this.addLien}>Ajouter un lien</button>
	            	)
	           	}
	        </div>
        )
    }
}

export default AuteurLiens


// WEBPACK FOOTER //
// ./auteur/liens/AuteurLiens.jsx